import React from 'react';
import { ArrowRight, LayoutDashboard } from 'lucide-react';

const DASHBOARD_PATH = /^\/dashboards\/[A-Za-z0-9]+$/;

/** "/dashboards/<id>" for a link to one of this app's dashboards, else null. */
export const dashboardPath = (href) => {
  if (!href) return null;
  try {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return DASHBOARD_PATH.test(url.pathname) ? url.pathname : null;
  } catch {
    return null;
  }
};

/** The agent's "here is your dashboard" link, shown as a card (create_dashboard result). */
const DashboardLinkCard = ({ path, children }) => (
  <a
    href={path}
    target="_blank"
    rel="noopener noreferrer"
    className="not-prose my-2 flex w-full max-w-md items-center gap-3 rounded-xl border border-[#5652CF]/40 bg-[#5652CF]/10 px-4 py-3 text-left transition-colors hover:bg-[#5652CF]/20"
  >
    <LayoutDashboard
      size={20}
      className="shrink-0 text-[#8b88ff]"
      aria-hidden="true"
    />
    <span className="min-w-0 flex-1">
      <span className="block truncate text-sm font-medium text-zinc-100">
        {children}
      </span>
      <span className="block text-xs text-zinc-400">Open dashboard</span>
    </span>
    <ArrowRight size={16} className="text-zinc-400" aria-hidden="true" />
  </a>
);

export default DashboardLinkCard;
